import { Credentials } from "auth";
import { Organization } from "generated/graphql";
import { ClientApp } from "models";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type UpdateApp = "UPDATE_APP";
export const UPDATE_APP: UpdateApp = "UPDATE_APP";
export type UpdateAppEnd = "UPDATE_APP_END";
export const UPDATE_APP_END: UpdateAppEnd = "UPDATE_APP_END";

export interface UpdateAppAction extends Action {
    type: UpdateApp;
    payload: {
        credentials: Credentials;
        app: ClientApp;
        organization?: Organization;
    };
}

export function updateApp(app: ClientApp): ThunkAction<any, State, any, UpdateAppAction> {
    return (dispatch: Dispatch<UpdateAppAction>, getState) => {
        const credentials = getState().auth.credentials;
        const organization = getState().org.currentOrg;

        dispatch(updateAppWithCredentials(app as ClientApp, organization, credentials));
    };
}

export function updateAppWithCredentials(
    app: ClientApp,
    organization: Organization,
    credentials: Credentials
): UpdateAppAction {
    return {
        payload: {
            app,
            credentials,
            organization
        },
        type: UPDATE_APP
    };
}

export interface UpdateAppEndAction extends Action {
    type: UpdateAppEnd;
    payload: {
        app?: ClientApp;
        error?: Error;
    };
}

export function updateAppEnd(error: Error, app?: ClientApp): UpdateAppEndAction {
    return {
        payload: {
            app,
            error
        },
        type: UPDATE_APP_END
    };
}
